import {clone} from '@/app-core/lib/utils/helper'
import Translatable from '@/app-core/mixins/translatable'
import ProductListCommon from '@/app-core/mixins/product/productListCommon'
import ProductPrice from '@/app-theme/components/product/ProductPrice.vue'
import ProductTags from '@/app-theme/components/product/ProductTags.vue'

export default {
  name      : 'CatalogProductListItem',
  components: {
    ProductTags,
    ProductPrice
  },
  directives: {},
  mixins    : [Translatable, ProductListCommon],
  props     : {
    product: {
      type   : Object,
      default: undefined
    },

    disabled: {
      type   : Boolean,
      default: false
    }
  },
  dataStore: {
    AppCart  : 'App.Cart',
    StoreMenu: 'Store.Menu'
  },
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    onProductClick() {
      if (!this.product || this.productDisabled || this.product?.Loading || (this.AppConfig.StoreClosed.DisableProductDialog && this.storeIsClosedById(this.product?.StoreId))) return

      this.$bus.$emit('product:details-dialog', clone(this.product))
    },

    onProductQuickAddClick() {
      if (!this.product || this.productDisabled || this.product?.Loading || (this.AppConfig.StoreClosed.DisableAddToCart && this.storeIsClosedById(this.product?.StoreId))) return

      this.$bus.$emit('cart:quick-add-product', this.product)
    }
  }
}
